
const envConfig = {
  Production: {
    apiServer: 'https://carrier-api.shipcompliant.com/api'
  },
  Staging: {
    apiServer: '//carriercompliance-staging-api.shipcompliant.com/api'
  },
  Test: {
    apiServer: '//carriercompliance-test-api.shipcompliant.com/api'
  },
  Local: {
    apiServer: '/api'
  },
  Dev: {
    apiServer: 'https://qa-carrier-api.shipcompliant-dev.com/api'
  },
  Qa: {
    apiServer: 'https://qa-carrier-api.shipcompliant-dev.com/api'
  },
  Uat: {
    apiServer: ''
  },
  Demo: {
    apiServer: ''
  },
};

export function getEnvironmentConfig() {
  const { hostname } = window.location;
  if (hostname.includes('test')) {
    return envConfig.Test;
  }
  if (hostname.includes('staging')) {
    return envConfig.Staging;
  }
  if (hostname.includes('local')) {
    return envConfig.Local;
  }
  if (hostname.includes('dev')) {
    return envConfig.Dev;
  }
  if (hostname.includes('qa')) {
    return envConfig.Qa;
  }
  if (hostname.includes('uat')) {
    return envConfig.Uat;
  }
  if (hostname.includes('demo')) {
    return envConfig.Demo;
  }
  // default to production so reduce the chance of getting the wrong config there.
  return envConfig.Production;
}

export default getEnvironmentConfig();
